export const useUserStore = defineStore('user-store', {

  persist: true,

  state: () => {
    return {
      userId: null,
      userCountry: null,
      countryModal: false,
      countrySelected: false,
      //
      searchActive: false,
      //
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmLandingPage: null,
      //
      sessionStart: null,
      removeModal3: false,
      mobileScrolledDown: false,
      mobileRemoveModal: false,
      canWatch: false,
      heroTest: null,
    }
  },

  actions: {

    setUserCountry(country) {
      this.userCountry = country
    },

    setHeroTest(test) {
      this.heroTest = test
    },

    startSession() {
      this.sessionStart = Date.now()
    },

    cookieSelection() {
      this.userCookieSelection = true
    },

    updateUtm(source, landingPage = null, medium = null, campaign = null) {
      this.utmSource = source
      this.utmMedium = medium
      this.utmCampaign = campaign
      this.utmLandingPage = landingPage
    },

    storeUserId(id) {
      this.userId = id
    },

    closeSearch() {
      this.searchActive = false
    },
    openSearch() {
      this.searchActive = true
    },
    closeCountryModal() {
      this.countryModal = false
    },
    openCountryModal() {
      this.countryModal = true
    },
    selectCountry() {
      this.countryModal = false
      this.countrySelected = true
    }

  }
})


if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
